import { render } from "./XIcon.vue?vue&type=template&id=06a3fa50"
import script from "./XIcon.vue?vue&type=script&lang=js"
export * from "./XIcon.vue?vue&type=script&lang=js"
script.render = render

export default script